import {
  Alert,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { snackbarUtils } from "../../utils";
import { useCreateUser } from "../../hooks/useUsers";

export default function UserAddDialog(props) {
  const { open, handleClose } = props;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);

  const createUserMutation = useCreateUser();

  useEffect(() => {
    if (!open) {
      setEmail("");
      setPassword("");
      setIsAdmin(false);
      createUserMutation.reset();
    }
  }, [open]);

  const generatePassword = () => {
    //generate a random secure password
    const length = 16;
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+~`|}{[]:;?><,./-=";
    let retVal = "";
    for (let i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }

    setPassword(retVal);
  };

  const addUser = () => {
    //check email is not blank and password is not blank
    if (!email) {
      snackbarUtils.updateMessage("Email cannot be blank");
      return;
    }

    if (!password) {
      snackbarUtils.updateMessage("Password cannot be blank");
      return;
    }

    const data = {
      email: email,
      password: password,
      role: isAdmin ? "admin" : "user",
    };

    createUserMutation.mutate(data, {
      onSuccess: () => {
        snackbarUtils.updateMessage("User added");
        handleClose();
      },
      onError: (error) => {
        if (error.response?.status === 409) {
          snackbarUtils.updateMessage("User already exists");
        } else {
          snackbarUtils.updateMessage("User add error");
        }
      },
    });
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Add User</DialogTitle>
      <DialogContent>
        <FormControl fullWidth>
          <TextField
            id="email"
            label="Email"
            variant="outlined"
            margin="normal"
            value={email}
            required
            fullWidth
            autoFocus
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
        </FormControl>
        <FormControl fullWidth>
          <TextField
            id="password"
            label="Password"
            variant="outlined"
            margin="normal"
            value={password}
            required
            fullWidth
            autoFocus
            onChange={(e) => {
              setPassword(e.target.value);
            }}
          />
        </FormControl>
        <Button variant="outlined" onClick={() => generatePassword()}>
          Generate Password
        </Button>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isAdmin}
                onChange={(e) => setIsAdmin(e.target.checked)}
                color="primary"
              />
            }
            label="Super Admin"
          />
        </FormControl>
        {isAdmin && (
          <Alert severity="warning" sx={{ mt: 2 }}>
            Super Admin gives this user access to the management environment
            and full access to all resources in the main app. Only grant this
            role to trusted users.
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="info" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="outlined" onClick={addUser}>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}
